var Backbone = require('backbone/backbone');

require('./MagItem.less');

module.exports = Backbone.View.extend({
    el: '.MagItem',

    events: {
        'click .MagItem-link .Button': 'onLinkClick'
    },

    initialize: function () {
    },

    onLinkClick: function (e) {
        ga('send', 'event', 'journal', 'click');
    }
});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MagItem/MagItem.js
// module id = 29
// module chunks = 0